import { useDispatch } from 'react-redux';
import { Grid, Button, Dialog, Box, Typography } from '@mui/material';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';

import {
  useGetAuthenticationQuery,
  useDeleteLocalDomainMutation,
} from '../../services/ADapi';

import { notificationSuccess } from '../../store/notificationReducer';

const DeleteLocalDomain = ({ localDomainId, onClose }) => {
  const dispatch = useDispatch();
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const [deleteLocalDomain] = useDeleteLocalDomainMutation();

  const notificationData = {
    isNotification: true,
    type: 'success',
    message: `Local domain deleted`,
  };

  const deleteLocalDomainHandler = async () => {
    try {
      await deleteLocalDomain({ user_id, id: localDomainId });
      dispatch(notificationSuccess(notificationData));
    } catch (error) {
      dispatch(
        notificationSuccess({
          isNotification: true,
          type: 'error',
          message: 'An error occured',
        })
      );
    }
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '48px',
          height: '48px',
          margin: 'auto',
          borderRadius: '50%',
          backgroundColor: 'warning.light',
        }}
      >
        <GppBadOutlinedIcon
          fontSize="medium"
          sx={{ color: 'primary.contrastText' }}
        />
      </Box>
      <Typography
        variant="h2"
        component="h3"
        sx={{ pt: 3, pb: 5, color: 'text' }}
      >
        Are you sure you want to delete this Local Domain?
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Button
            variant="error"
            onClick={deleteLocalDomainHandler}
            size="small"
            sx={{
              width: '100%',
              backgroundColor: 'error.main',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'error.main',
              },
            }}
          >
            Delete
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button
            variant="outlined"
            onClick={onClose}
            size="small"
            sx={{
              width: '100%',
            }}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default DeleteLocalDomain;
